/* eslint-disable max-len */
const React = require('react');

const Expand = ({ openModal }) => (
  <svg
    onClick={openModal}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
>
    <path
      fill="#000"
      fillOpacity="0.55"
      fillRule="evenodd"
      d="M8.5 1.4h6.1v6.1h-1.2V3.448L9.424 7.424l-.848-.848L12.552 2.6H8.5V1.4zM7.5 14.6H1.4V8.5h1.2v4.052l3.976-3.976.848.848L3.45 13.4H7.5v1.2z"
      clipRule="evenodd"
   />
  </svg>
);

module.exports = Expand;

